<template>
  <div class="home">
  
    <Reproductor msg="Los colores" audio2="../mp3/PrimariaD/05PD.mp3" cover="../img/4.jpg" name="Primaria D - Lección #5"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
